import script from "./HelmOpAdvancedTab.vue?vue&type=script&setup=true&lang=js"
export * from "./HelmOpAdvancedTab.vue?vue&type=script&setup=true&lang=js"

import "./HelmOpAdvancedTab.vue?vue&type=style&index=0&id=8b7158e0&lang=scss&scoped=true"

import exportComponent from "../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b7158e0"]])

export default __exports__